export function cycle(array, n) {
  return array[n % array.length];
}
